import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useHandleError } from '@dotfile/frontend/shared/components';
import {
  SwitchCaseInput,
  useSwitchCaseMutation,
} from '@dotfile/shared/data-access-client-portal';

import { useClientPortalId } from '../../../shared';

export const useSwitchCase = () => {
  const [runMutation, result] = useSwitchCaseMutation();
  const currentClientPortalId = useClientPortalId();
  const { t } = useTranslation();

  const handleError = useHandleError();

  const switchCase = useCallback(
    async (input: SwitchCaseInput) => {
      try {
        if (!currentClientPortalId) {
          return false;
        }

        const { data } = await runMutation({
          variables: {
            input,
          },
        });

        if (data) {
          document.location.assign(data.switchCase.link);
        }

        return data?.switchCase?.link;
      } catch (error) {
        handleError({
          title: t('onboardings.switch_case.error', {
            ns: 'client-portal',
            defaultValue:
              'Could not switch to the selected onboarding, please contact support.',
          }),
          error,
        });

        return false;
      }
    },
    [runMutation, handleError, currentClientPortalId, t],
  );

  return [switchCase, result] as const;
};
